import { ModuleFE_AdvisorBoard, ModuleFE_ProtocolInteraction } from '../_enum.js';
import { ModuleFE_AdvisorSettings } from './ModuleFE_AdvisorSettings/index.js';
import { ModuleFE_Inbox } from './module-inbox/ModuleFE_Inbox.js';
import { ModuleFE_PanelFindings } from './ModuleFE_PanelFindings/ModuleFE_PanelFindings.js';
import { ModuleFE_Spotlight } from './ModuleFE_Spotlight/index.js';
import { ModuleFE_AdvisorWindowMessenger, ModuleFE_EncounterStorage, ModuleFE_Provider } from '@app/advisor-frontend';
import { ModuleFE_AdvisorMini } from './ModuleFE_AdvisorMini.js';
import { ModuleFE_ProvideInfo } from './provide-info/ModuleFE_ProvideInfo.js';
import { ModuleFE_ExplainV2 } from './explain/ModuleFE_ExplainV2.js';
import { ModuleFE_AdvisorAnalytics } from '../_analytics/consts.js';
import { ModuleFE_Recap } from './ModuleFE_Recap/ModuleFE_Recap.js';
import { ModuleFE_AdvisorEvents } from './ModuleFE_AdvisorEvents/ModuleFE_AdvisorEvents.js';
import { ModuleFE_LiveMDM } from './ModuleFE_LiveMDM.js';
import { ModuleFE_Notes } from './ModuleFE_Notes/ModuleFE_Notes.js';
export const ModulePackFE_AdvisorUI = [
    ModuleFE_AdvisorBoard,
    ModuleFE_AdvisorMini,
    ModuleFE_LiveMDM,
    ModuleFE_Inbox,
    ModuleFE_PanelFindings,
    ModuleFE_ProtocolInteraction,
    ModuleFE_AdvisorSettings,
    ModuleFE_Provider,
    ModuleFE_Spotlight,
    ModuleFE_AdvisorWindowMessenger,
    ModuleFE_EncounterStorage,
    ModuleFE_ProvideInfo,
    ModuleFE_ExplainV2,
    ModuleFE_AdvisorAnalytics,
    ModuleFE_AdvisorEvents,
    ModuleFE_Recap,
    ModuleFE_Notes,
];
//# sourceMappingURL=module-pack.js.map